<template>
  <div class="i-number" @wheel.stop="wheel">
    <div class="i-number__container pdg--">
      <input
        ref="input"
        type="number"
        :value="value"
        :style="{ width }"
        :max="max"
        :min="min"
        @input="$emit('input', $refs.input.value)"
      />
      <span v-if="unit">{{ unit }}</span>
    </div>
    <div class="i-number__arrows mrgl--">
      <Btn
        class="mrgb--"
        variant="link"
        @click.stop="$emit('input', +$refs.input.value + 1)"
      >
        <Icon id="chevron-up" :scale="0.6" />
      </Btn>
      <Btn variant="link" @click.stop="$emit('input', +$refs.input.value - 1)">
        <Icon id="chevron-down" :scale="0.6" />
      </Btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    unit: { type: String, default: null },
    value: { type: [Number, String], required: true },
    min: { type: Number, default: null },
    max: { type: Number, default: null },
  },

  computed: {
    width() {
      const digits =
        this.max?.toString().length || (+this.value).toString().length;
      return digits ? `${digits}em` : '2em';
    },
  },

  watch: {
    value(watchedValue) {
      let newValue;
      if (this.max) {
        newValue = Math.min(this.max, watchedValue);
      }
      if (this.min) {
        newValue = Math.max(this.min, watchedValue);
      }
      this.$emit('input', newValue);
    },
  },

  methods: {
    /**
     * @param {WheelEvent} e the wheel event
     */
    wheel(e) {
      let value = +this.$refs.input.value - Math.round(e.deltaY / 10);
      if (this.max) {
        value = Math.min(this.max, value);
      }
      if (this.min) {
        value = Math.max(this.min, value);
      }
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.i-number {
  display: inline-flex;
  align-items: center;

  &__container {
    display: flex;
    align-items: center;
    border: 1px solid $alt-200;
    border-radius: $border-radius-default;

    > input {
      appearance: textfield;
      margin: 0;
      border: 0;
      font-weight: bold;
      text-align: right;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }

    > span {
      color: $alt-500;
    }
  }
  &__arrows {
    display: flex;
    flex-direction: column;

    > button {
      all: unset;
      height: min-content;
      display: flex;
      align-items: center;
    }
  }
}
</style>
